import { EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../app/api.service';
import { StoreService } from '../../app/store.service';
import { CommonService } from '../../app/common.service';
var ComponentMenuBar = (function () {
    function ComponentMenuBar(router, store, commonService, apiService, storeService) {
        this.router = router;
        this.store = store;
        this.commonService = commonService;
        this.apiService = apiService;
        this.storeService = storeService;
        this.showMentorRedDot = false;
        this.logout = new EventEmitter();
        this.showGDPR = new EventEmitter();
        this.mentorEntered = new EventEmitter();
        this.menuBarClose = new EventEmitter();
        this.showScreenClassName = '';
        this.dialogOpacity = 0;
        this.dialogDisplay = 'none';
        this.multiValidUserAccount = false;
        this.isChannel = false;
        this.isShowCover = false;
        this.mentorEnteredLocal = false;
    }
    Object.defineProperty(ComponentMenuBar.prototype, "showToastFlag", {
        get: function () {
            if (!this.exerciseBook || !this.exerciseBook.length) {
                return true;
            }
            return this.exerciseBook.every(function (item) {
                return item.toastFlag === 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentMenuBar.prototype, "showHamburgerRedDot", {
        get: function () {
            return !this.showToastFlag || this.showMentorRedDot;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentMenuBar.prototype, "hasLeaderCoach", {
        get: function () {
            return this.commonService.hasLeaderCoachAuthority(this.userAuthority);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentMenuBar.prototype, "showTools", {
        get: function () {
            return this.isHaveTools || this.commonService.hasToolsAuthority(this.userAuthority);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentMenuBar.prototype, "showMentorNewBadge", {
        get: function () {
            return this.hasLeaderCoach && !this.mentorEnteredLocal;
        },
        enumerable: true,
        configurable: true
    });
    ComponentMenuBar.prototype.showOrCloseFullPage = function () {
        var _this = this;
        var wasOpen = this.showScreenClassName === 'open';
        var newClassName = this.showScreenClassName == 'open' ? '' : 'open';
        this.showScreenClassName = newClassName;
        this.isShowCover = newClassName === 'open';
        if (wasOpen && newClassName === '') {
            this.menuBarClose.emit();
        }
        if (newClassName === 'open') {
            if (this.commonService.isPasswordLogin()) {
                this.multiValidUserAccount = false;
            }
            else {
                this.apiService.getCompanyList().subscribe(function (result) {
                    if (Array.isArray(result) && result.filter(function (item) { return item.state === 1; }).length > 1) {
                        _this.multiValidUserAccount = true;
                    }
                    else {
                        _this.multiValidUserAccount = false;
                    }
                });
            }
        }
    };
    ComponentMenuBar.prototype.handleSwitch = function () {
        sessionStorage.removeItem('userSession');
        this.showScreenClassName = '';
        var link = ['course-select'];
        this.router.navigate(link);
    };
    ComponentMenuBar.prototype.openLogoutDialog = function () {
        this.showScreenClassName = '';
        this.isShowCover = false;
        localStorage.removeItem('userName');
        this.logout.emit();
    };
    ComponentMenuBar.prototype.closeSmallDialog = function () {
        var _this = this;
        this.dialogOpacity = 0;
        setTimeout(function () {
            _this.dialogDisplay = 'none';
        }, 0);
    };
    ComponentMenuBar.prototype.handleBtnClick = function (type) {
        var _this = this;
        this.closeSmallDialog();
        if (type === 'left') {
            this.showOrCloseFullPage();
            this.apiService.logout().subscribe(function (res) {
                if (res) {
                    console.log(res, '登出接口');
                    //清除多公司记录
                    _this.commonService.clearLoginCredentials();
                    _this.commonService.clearMentorEnteredLocal();
                    _this.storeService.notification.mentorEntered.next(null);
                    localStorage.removeItem('userId');
                    localStorage.removeItem('transtalen-token');
                    localStorage.removeItem('transtalenuserid');
                    _this.router.navigate(['new-login']);
                }
            });
        }
    };
    ComponentMenuBar.prototype.getUserInfoAPI = function () {
        return this.apiService.getUserInfo().toPromise();
    };
    ComponentMenuBar.prototype.getUserCampAPI = function () {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/camp/list'
        }).toPromise();
    };
    ComponentMenuBar.prototype.goGDPR = function () {
        this.showScreenClassName = '';
        this.isShowCover = false;
        this.showGDPR.emit();
    };
    ComponentMenuBar.prototype.goExerciseBook = function () {
        this.commonService.learningPortEventLogByCandy({ 'userId': localStorage.getItem('userId'), 'learningPathMetaId': '', 'module': '作业', 'btnName': '点击作业薄', 'courseUnit': '', 'type': 0 }).then();
        this.router.navigate(['exercise-book']);
    };
    ComponentMenuBar.prototype.goTools = function () {
        this.showScreenClassName = '';
        this.isShowCover = false;
        this.router.navigate(['app-tools']).then();
    };
    ComponentMenuBar.prototype.goAiCoach = function () {
        this.showScreenClassName = '';
        this.isShowCover = false;
        this.router.navigate(['app-ai-coach']).then();
    };
    ComponentMenuBar.prototype.goLearningCenter = function () {
        this.showScreenClassName = '';
        this.isShowCover = false;
        if (this.router.url.indexOf('learning-map') === -1) {
            this.router.navigate(['learning-map']);
        }
    };
    ComponentMenuBar.prototype.goLeaderCoach = function () {
        if (!this.commonService.canEnterLeaderCoach(this.userAuthority)) {
            return;
        }
        this.showScreenClassName = '';
        this.isShowCover = false;
        var url = this.commonService.appendTokenToUrl(this.commonService.getLeaderCoachUrl(this.userAuthority));
        // 必须先落「已进导师」标记再跳外链，否则手机返回后 setOnceIno 常被取消，红点仍在
        this.markMentorEntered().then(function () {
            window.location.href = url;
        });
    };
    ComponentMenuBar.prototype.markMentorEntered = function () {
        if (this.commonService.isMentorGuideDebugMode()) {
            return Promise.resolve();
        }
        if (this.mentorEnteredLocal && this.commonService.hasMentorEnteredLocal()) {
            return Promise.resolve();
        }
        this.mentorEnteredLocal = true;
        this.commonService.markMentorEnteredLocal();
        this.storeService.notification.mentorEntered.next(true);
        this.mentorEntered.emit();
        return this.commonService.setOnceIno(this.commonService.MENTOR_ENTERED_ONCE_VALUE)
            .toPromise()
            .then(function () { return undefined; })
            .catch(function () { return undefined; });
    };
    ComponentMenuBar.prototype.goToTerms = function () {
        window.open('https://terms.transtalent.cn/');
    };
    ComponentMenuBar.prototype.goPrivacy = function () {
        window.open('https://oss.transtalent.cn/');
    };
    ComponentMenuBar.prototype.getUserHaveTools = function () {
        return this.apiService.ajax({
            'type': 'GET',
            'url': '/sr/tools/yyToolsLibrary/haveToolsAuthority'
        }).toPromise();
    };
    ComponentMenuBar.prototype.checkMentorEntered = function () {
        var _this = this;
        if (this.commonService.isMentorGuideDebugMode()) {
            this.mentorEnteredLocal = false;
            return;
        }
        if (this.commonService.hasMentorEnteredLocal()) {
            this.mentorEnteredLocal = true;
        }
        this.commonService.getOnceIno(this.commonService.MENTOR_ENTERED_ONCE_VALUE).then(function (result) {
            _this.mentorEnteredLocal = result === 1 || _this.commonService.hasMentorEnteredLocal();
            if (result === 1) {
                _this.commonService.markMentorEnteredLocal();
            }
        });
    };
    /** 导师引导点击后同步 NEW：未进过导师时强制展示 */
    ComponentMenuBar.prototype.syncMentorBadgeAfterGuide = function (shouldShowNew) {
        if (this.commonService.isMentorGuideDebugMode()) {
            this.mentorEnteredLocal = false;
            return;
        }
        if (shouldShowNew) {
            this.mentorEnteredLocal = false;
        }
    };
    ComponentMenuBar.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRouteUrl = this.assetsRoute + '/picture/camp/headPortrait.png';
        this.checkMentorEntered();
        this.mentorRedDotSub = this.storeService.notification.mentorEntered.subscribe(function (value) {
            if (value === true) {
                _this.mentorEnteredLocal = true;
            }
            else if (value === null) {
                // 账号切换重置：按当前账号重新校验，避免沿用上一账号的 true
                _this.mentorEnteredLocal = false;
                _this.checkMentorEntered();
            }
        });
        this.getUserInfoAPI().then(function (result) {
            if ('code' in result && !('id' in result)) {
                return;
            }
            if (result) {
                _this.avatarUrl = result.headimgurl;
                _this.userName = result.name;
                _this.accountName = result.accountNumber || (result.phone.substr(0, 3) + "****" + result.phone.substr(7, 4));
                _this.isChannel = result.isChannel === 1;
                _this.storeService.notification.isChannel.next(_this.isChannel);
            }
        }).then(function () {
            return _this.getUserHaveTools().then(function (result) {
                return _this.isHaveTools = result;
            });
        }).then(function () {
            return _this.getUserCampAPI().then(function (result) {
                return _this.userCamp = result;
            });
        });
    };
    ComponentMenuBar.prototype.ngOnDestroy = function () {
        if (this.mentorRedDotSub) {
            this.mentorRedDotSub.unsubscribe();
        }
    };
    return ComponentMenuBar;
}());
export { ComponentMenuBar };



// WEBPACK FOOTER //
// ./src/component-ui/menu-bar/component.ts.pre-build-optimizer.js